import { SalesCourseIntakesCourseDto } from '@wisenet/salesapp-client'
import { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styled from 'styled-components'
import courseSM from '../../assets/course-sm.jpg'
import { Button } from '../../elements/Button'
import { useAppSelector } from '../../types/assets'
import { courseImgURLGetter } from '../../utils/assets'

export type CourseItemProps = {
  course: SalesCourseIntakesCourseDto
}

const StyledCourseItem = styled.div`
  display: flex;
  flex-direction: column;
  background: #f7f7f7ad;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0px 2px 1px 0.4px rgba(0, 0, 0, 0.06);
  max-width: 300px;

  :hover {
    transform: scale(1.01);
    transition: transform 0.3s ease;
  }
  .header-image {
    background-image: url(${({ imageSrc }: { imageSrc?: string }) => imageSrc}), url(${courseSM});
    background-size: cover;
    height: 100px;
    width: 100%;
    overflow: hidden;
    img {
      width: 100%;
    }
  }

  .course-details {
    height: 130px;
    display: flex;
    flex-direction: column;
    padding: 5px 20px;

    .course-name {
      color: black;
      font-size: 14px;
      font-weight: 500;
      display: block;
      overflow: hidden;
      max-height: 40px;
      line-height: 20px;
    }

    .course-id {
      color: ${props => props.theme.fontColor};
      text-transform: uppercase;
      display: block;
      margin-top: 12px;
      font-size: 10pt;
      margin-bottom: 5px;
      min-height: 15px;
    }
  }

  @media only screen and (max-width: 600px) {
    max-width: 100%;
  }
`

const UnMemoizedCourseItem = ({ course }: CourseItemProps) => {
  const { tenantCode, path } = useAppSelector(state => state.settings.config)

  const imageURL = courseImgURLGetter(tenantCode, 'sm', course.courseGuid)

  return (
    <StyledCourseItem
      key={course.courseGuid}
      imageSrc={imageURL}
    >
      <div className="header-image" />
      <div className="course-details">
        <span className="course-id">{course?.publishCode === 'null' ? '' : course.publishCode}</span>
        <label className="course-name">{course.publishName === 'null' ? '' : course.publishName}</label>
        <Button
          to={`/${path}/courses/${course.courseGuid}`}
          label="COURSE INFO"
        />
      </div>
    </StyledCourseItem>
  )
}

export const CourseItemSkeleton = () => {
  return (
    <StyledCourseItem>
      <div className="header-image">
        <Skeleton height={'100px'} />
      </div>
      <div className="course-details">
        <span className="course-id">
          {' '}
          <Skeleton
            height="25px"
            width={'50%'}
          />
        </span>
        <label className="course-name">
          <Skeleton height="25px" />
        </label>
      </div>
    </StyledCourseItem>
  )
}

export const CourseItem = memo(UnMemoizedCourseItem)
